import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import algoliasearch from 'algoliasearch/lite';
import {InstantSearch, SearchBox, Configure, Hits, connectStats,
  connectPagination} from 'react-instantsearch-dom';
import {Container} from 'react-bootstrap';
import SearchCard from './SearchCard';
import * as styles from '../Styles/search.module.scss';
import * as trackAction from '../../Application/Shared/TrackActionService';
import {getParameterByName} from '../../Application/Shared/UrlUtils';


const algoliaClient = algoliasearch(
    process.env.AlgoliaApplicationId, process.env.AlgoliaAdminApiKey);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    const newRequests = requests.map((request) => {
      if (!request.params.query || request.params.query.length === 0) {
        request.params.analytics = false;
      }
      return request;
    });
    return algoliaClient.search(newRequests);
  },
};

const Stats = ({nbHits, searchTerm}) => {
  useEffect(()=>{
    trackAction.searchEnteredAction({
      searchTerm,
      hitsCount: nbHits,
    });
  }, [searchTerm]);

  return (
    <p>
      Total results - {nbHits}
    </p>
  );
};

const CustomStats = connectStats(Stats);

const Pagination = ({currentRefinement, nbPages, refine}) => {
  let page=currentRefinement;
  const changePage = (param) => {
    if (param==='back') {
      page=page-1;
    } else {
      page=page+1;
    }
    refine(page);
  };
  return <div className={styles.courseListInfo}>
    <div className={styles.ctaSection}>
      <div
        className={`${styles.backCta} ${page<=1 ?
          styles.disable : ''}`}
        onClick={() => changePage('back')}
      >
        <div
          className={`library-brand-icon-new`}>
          <i className="icon-new-back-arrow"></i>
        </div>
      </div>
      <div
        className={`${styles.nextCta} ${page===nbPages || nbPages<=1 ?
        styles.disable : ''}`}
        onClick={() => changePage('next')}>
        <div
          className={`library-brand-icon-new`}>
          <i className="icon-new-right-arrow"></i>
        </div>
      </div>
    </div>
    <div className={styles.pageInfoSection}>
      <p>{nbPages ? currentRefinement : 0} - {nbPages}</p>
    </div>
  </div>;
};

const CustomPagination = connectPagination(Pagination);

const TotalHits = ({nbHits}) => (
  <p>1 - {Math.floor(nbHits/6)}</p>
);


const Search = (props) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showHits, setShowHits] = useState(false);

  useEffect(() => {
    if (props.defaultSearchParam) {
      setShowSearch(true);
      setSearchTerm(props.defaultSearchParam);
      setShowHits(true);
    }
  }, [props.defaultSearchParam]);

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
    if (e.target.value.length>2) {
      setShowSearch(true);
      setShowHits(true);
    } else {
      setShowHits(false);
    }
    if (props.isCatalogueSearch) {
      if (e.target.value.length<=2) {
        setShowSearch(false);
      }
    }
  };

  const closeSearchResult = () => {
    setShowSearch(false);
    setSearchTerm('');
  };

  return (
    <div className={`${styles.searchWrapper}
      ${props.isCatalogueSearch ? styles.headerSearch : '' }
      ${props.isCatalogueSearch===true &&
        props.isHomepage===false ? styles.searchBar : ''} `}
    >
      <div className={styles.searchDetails}>
        <div>
          <div className={styles.algoliaSearch}>
            <InstantSearch searchClient={searchClient}
              indexName={process.env.AlgoliaLessonsSearchCollection}>
              <div className={styles.search}>
                <SearchBox
                  translations = {{placeholder: 'Search courses'}}
                  autoFocus
                  showLoadingIndicator
                  onChange={handleChange}
                  defaultRefinement={props.defaultSearchParam}
                />
                <div
                  className={`library-brand-icon-new`}>
                  <i className="icon-new-Search1"></i>
                </div>
              </div>
              {showSearch && <>
                <Configure hitsPerPage={6}/>
                <div className={styles.displayHits}>
                  <div className={styles.searchContainer}>
                    <div className={styles.totalHits}>
                      <div className={styles.close}
                        onClick={closeSearchResult}>
                        <img src='/images/review/close.svg'
                          // eslint-disable-next-line react/no-unknown-property
                          datasrc='/images/review/close.svg'
                          alt="close"/>
                      </div>
                      <div className={styles.flexPagination}>
                        <CustomStats searchTerm={searchTerm}/>
                        <CustomPagination />
                      </div>
                    </div>
                    <div className={styles.hitsSection}>
                      <Hits hitComponent={SearchCard}/>
                    </div>
                  </div>
                </div>
              </>}
            </InstantSearch>
          </div>
        </div>
      </div>
    </div>
  );
};

TotalHits.propTypes = {
  nbHits: PropTypes.object,
};
Stats.propTypes = {
  nbHits: PropTypes.object,
  searchTerm: PropTypes.string,
};
Search.propTypes = {
  isCatalogueSearch: PropTypes.bool,
  isHomepage: PropTypes.bool,
  defaultSearchParam: PropTypes.string,
};

Pagination.propTypes = {
  currentRefinement: PropTypes.number,
  nbPages: PropTypes.number,
  refine: PropTypes.func,
  isCatalogueSearch: PropTypes.bool,
};
export default Search;
